/*
  Shared image lightbox: the product gallery and the "Look inside" section.

  Uses a native <dialog>, so Escape, the top layer and the backdrop are the
  browser's job rather than ours. Focus return is handled by showModal().

  Opt in by giving a container data-lightbox and each trigger data-lightbox-item
  with data-full (large src) and data-caption. Order follows DOM order, which
  is what a keyboard user tabs through, so arrow keys agree with the page.
*/
(function () {
  var dialog, imgEl, capEl, counterEl, items = [], index = 0;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'lbx';
    if (reduced) dialog.setAttribute('data-reduced', '');
    dialog.innerHTML =
      '<div class="lbx__inner">' +
        '<button class="lbx__close" type="button" aria-label="Close">Close</button>' +
        '<figure class="lbx__figure">' +
          '<img class="lbx__img" alt="">' +
          '<figcaption class="lbx__cap"></figcaption>' +
        '</figure>' +
        '<div class="lbx__nav">' +
          '<button class="lbx__prev" type="button" aria-label="Previous page">Previous</button>' +
          '<p class="lbx__count" aria-live="polite"></p>' +
          '<button class="lbx__next" type="button" aria-label="Next page">Next</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);

    imgEl = dialog.querySelector('.lbx__img');
    capEl = dialog.querySelector('.lbx__cap');
    counterEl = dialog.querySelector('.lbx__count');

    dialog.querySelector('.lbx__close').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('.lbx__prev').addEventListener('click', function () { step(-1); });
    dialog.querySelector('.lbx__next').addEventListener('click', function () { step(1); });

    // Clicking the backdrop (the dialog itself, outside .lbx__inner) closes.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
  }

  function show(i) {
    index = (i + items.length) % items.length;
    var el = items[index];
    imgEl.src = el.getAttribute('data-full') || el.getAttribute('src') || '';
    // The trigger's own alt is the accessible name; a decorative thumb has none,
    // in which case the caption carries the meaning.
    imgEl.alt = el.getAttribute('data-alt') || '';
    var cap = el.getAttribute('data-caption') || '';
    capEl.textContent = cap;
    capEl.hidden = cap === '';
    counterEl.textContent = (index + 1) + ' of ' + items.length;
    dialog.querySelector('.lbx__nav').hidden = items.length < 2;
  }

  function step(d) { show(index + d); }

  function init(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-lightbox-item]'));
    if (!triggers.length) return;
    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        items = triggers;
        if (!dialog) build();
        show(triggers.indexOf(t));
        dialog.showModal();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-lightbox]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Sections re-render in the theme editor; re-bind so it keeps working there.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lightbox]').forEach(init);
  });
})();
